<template>
  <div class="insured-mobile">
    <div class="section_" v-for="(insured, index) in batchInsureList" :key="insured.insureId">
      <correct-title :title="'被保人' + (index + 1)" />
      <a-row v-if="insured.correctType !== '新增'">
        <!-- 循环被保人字段 -->
        <template v-for="item in editItems">
          <a-col :xs="24" :sm="24" :md="12" :lg="8" v-if="!item.isHide" :key="item.key">
            <form-item :fieldItem="item" :editForm="insured" :editIndex="index" :labelCol="labelCol" :wrapperCol="wrapperCol"></form-item>
          </a-col>
        </template>
      </a-row>
      <a-row v-else>
        <!-- 循环被保人字段 -->
        <template v-for="item in addItems">
          <a-col :xs="24" :sm="24" :md="12" :lg="8" v-if="!item.isHide" :key="item.key">
            <form-item :fieldItem="item" :editForm="insured" :editIndex="index" :labelCol="labelCol" :wrapperCol="wrapperCol"></form-item>
          </a-col>
        </template>
        <a-col :xs="24" :sm="24" :md="12" :lg="8">
          <div class="btn-div del-btn-div">
            <a-button class="del-btn" icon="delete" @click="del(index)">删除被保人</a-button>
          </div>
        </a-col>
      </a-row>
    </div>
    <div v-if="hasAdd" class="btn-div add-btn-div">
      <a-button class="add-btn" icon="plus" @click="add">新增被保人</a-button>
    </div>
  </div>
</template>

<script>
import { insuredMixins } from '@/views/correct/mixins/insuredMixins';
import commonOptions from '../common/options';
import correctTitle from './title';
import formItem from '../components/formItem/index.vue';
export default {
  name: 'insuredEdit',
  mixins: [insuredMixins],
  components: {
    correctTitle,
    formItem
  },
  props: {
    // 保单form数据
    batchInsureList: {
      type: Array,
      default: () => []
    },
    // 被保人修改需要的配置数据
    insuredCfg: {
      type: Object,
      default: () => {}
    },
    // 保单生效日期
    effectiveDate: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelCol: { xs: 8, sm: 6, md: 4 },
      wrapperCol: { xs: 16, sm: 18, md: 16 }
    };
  },
  computed: {
    // 计算被保人组件配置数据
    editItems() {
      let editItems = [
        { label: '批单生效日', key: 'batchDate', type: 'date', writeable: true, required: true, disabledDate: this.batchDateDisDate, changeFn: this.changeFn },
        { label: '批改类型', key: 'correctType' },
        { label: '被保人姓名', key: 'name', writeable: true, required: true, blurFn: this.changeFn },
        { label: '证件类型', key: 'idType', type: 'select', writeable: true, required: true, dataSource: commonOptions.idTypeOps, changeFn: this.changeFn },
        { label: '证件号码', key: 'idNumber', writeable: true, required: true, blurFn: this.changeFn },
        { label: '出生日期', key: 'birthDate', type: 'date', disabledDate: this.birthdateDisDate, writeable: true, required: true, changeFn: this.changeFn },
        { label: '性别', key: 'gender', type: 'select', writeable: true, required: true, dataSource: commonOptions.genderOps, changeFn: this.changeFn },
        { label: '手机号', key: 'mobile', writeable: true, blurFn: this.changeFn },
        { label: '保费', key: 'premium' }
      ];
      // 如果传递的配置存在，则用传递的配置
      if (this.insuredCfg && this.insuredCfg.editItems && this.insuredCfg.editItems.length > 0) {
        editItems = [];
        this.insuredCfg.editItems.forEach(cfg => {
          cfg.items.forEach(item => {
            if (!item.deviceType || item.deviceType === 'm') {
              item.editType = cfg.type;
              editItems.push(item);
            }
          });
        });
      }
      return editItems;
    },
    // 被保人新增配置
    addItems() {
      let addItems = [];
      this.insuredCfg.addItems.forEach(cfg => {
        cfg.items.forEach(item => {
          if (!item.deviceType || item.deviceType === 'm') {
            item.editType = cfg.type;
            addItems.push(item);
          }
        });
      });
      return addItems;
    }
  },
  methods: {
    // 新增被保人
    add() {
      const editIndex = this.batchInsureList.findIndex(item => item.correctType === '修改');
      if (editIndex > -1) {
        this.$message.error('当前已修改被保人信息，不可同时新增被保人');
        return false;
      }
      this.type = 1;
      this.$emit('addInsuredMobile', this.type);
    },
    // 删除被保人
    del(index) {
      const addIndex = this.batchInsureList.findIndex((item, i) => i !== index && item.correctType === '新增');
      if (addIndex < 0) {
        this.type = 0;
      }
      this.$emit('delInsuredMobile', index, this.type);
    },
    // 被保人数据修改通用方法
    changeFn(index, value, type) {
      this.$emit('changeInsured', index, value, type);
    }
  }
};
</script>

<style lang="scss">
.mobile_ {
  .insured-mobile {
    .ant-form-item.required_ {
      label {
        &::before {
          display: inline-block;
          margin-right: 4px;
          color: #f5222d;
          font-size: 14px;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: '*';
        }
      }
    }
    .btn-div {
      text-align: center;
      margin-bottom: 16px;
      &.add-btn-div {
        padding: 0 20px;
      }
      &.del-btn-div {
        margin-top: 16px;
      }
      .add-btn,
      .del-btn {
        width: 100%;
        height: 40px;
        border: 1px solid #ffeee9;
        border-radius: 10px;
        color: #333333;
        i {
          color: #ff3600;
        }
      }
      .del-btn {
        background: linear-gradient(270deg, #fff2f2 0%, #fdf9f9 100%) !important;
      }
    }
  }
}
</style>
